const searchInput = document.getElementById('searchInput');

if (searchInput) {
  const searchResults = document.getElementById('searchResults');
  const resultsList = searchResults.querySelector('.search-results__list');
  const lang = window.location.pathname.startsWith('/fr') ? 'fr' : 'en';

  let debounceTimer;

  function hideResults() {
    searchResults.classList.add('hidden');
  }

  function showResults() {
    searchResults.classList.remove('hidden');
  }

  function clearResults() {
    resultsList.innerHTML = '';
  }

  // Fonction pour faire la requête de recherche
  async function performSearch(query) {
    if (!query) {
      hideResults();
      return;
    }

    try {
      const response = await fetch(`/api/v1/docs/search?q=${encodeURIComponent(query)}&lang=${lang}`);
      if (!response.ok) {
        console.error('Erreur du serveur lors de la recherche');
        hideResults();
        return;
      }
      const result = await response.json();
      if (result.status === 'success') {
        const articles = result.data; // tableau d’articles
        if (!articles.length) {
          clearResults();
          resultsList.innerHTML = `<li class="search-results__item">${
            lang === 'fr' ? 'Aucun résultat' : 'No results found'
          }</li>`;
          showResults();
          return;
        }

        clearResults();
        articles.forEach((art) => {
          const li = document.createElement('li');
          li.classList.add('search-results__item');
          // Choix du titre selon la langue active
          const title = lang === 'fr' ? art.titleFr : art.titleEn;
          // Optionnel : vous pouvez aussi inclure la description
          const description = lang === 'fr' ? art.descriptionFr : art.descriptionEn;
          li.innerHTML = `
          <div class="search-results__item--container">
            <div class="search-results__item--title"><strong>${title}</strong></div>
            <div class="search-results__item--description"><small>${description}</small></div>
          </div>
        `;
          // Construction de l'URL de l'article
          li.addEventListener('click', () => {
            window.location.href = `${lang === 'fr' ? '/fr' : ''}/docs/${art.categorySlug}/${art.subCategory}/${
              art.slug
            }`;
          });
          resultsList.appendChild(li);
        });
        showResults();
      } else {
        hideResults();
      }
    } catch (err) {
      console.error('Erreur de connexion ou JS', err);
      hideResults();
    }
  }

  // Debounce : retarde l’appel pour éviter de spammer le serveur
  function handleSearchInput() {
    const query = searchInput.value.trim();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      performSearch(query);
    }, 300);
  }

  searchInput.addEventListener('input', handleSearchInput);

  // Cacher les résultats si on clique en dehors
  document.addEventListener('click', (e) => {
    if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
      hideResults();
    }
  });

  // Cacher les résultats si on appuie sur Echap
  searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      hideResults();
    }
  });
}
